<template>
<div class="main_box">
    <div class="back" :class="{ 'hidden' : store.currentPage === 1}" @click="store.setPrevPage()">
        <SvgHeaderSvg :type="'left'" class="largeBack"/>
    </div>
    <div class="title_block mb-3">
        <div class="text-center">
            <h3 class="font-active">Diamond Quiz</h3>
            <p>find your perfect diamond</p>
        </div>
    </div>
    <div class="close" @click="emitClosePage">
        <SvgHeaderSvg :type="'close'" class="largesvg"/>
    </div>
</div>


</template>

<script setup>
import { diamondQuizStore } from '@/stores/diamond_quiz/diamond_quiz';

const store = diamondQuizStore()




const emit = defineEmits(['closePage','prePage'])

const emitClosePage = () => {
  emit('closePage')
}

</script>


<style scoped>
.back.hidden {
  visibility: hidden;
}

.largesvg {
    transform: scale(1.3);
}

.largeBack {
    transform: scale(1.6);
}
.title_block {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 90%;
    margin-top: 2%;
}

.main_box{
    display: flex;
    justify-content: space-between;
}

h3 {
    font-size: 32px;
    font-weight: 400;
    color: #212529;
}

.title_block p {
    font-size: 16px;
    color: #353535;
    letter-spacing: 4px;
    text-transform: uppercase;
}

.back {
    padding: 5px;
    cursor: pointer;
    width: 5%;
}

.close {
    cursor: pointer;
    width: 5%;
    text-align: right;
}

@media(max-width: 768px) {
    h3 {
        font-size: 24px;
    }

    .title_block p {
        font-size: 14px;
        letter-spacing: 1.5px;
        color: #606060;
        margin-bottom: 0;
    }

    .title_block {
        margin-bottom: 0;
    }

    .title_block {
        width: 88%;
    }

    .close {
        width: 7%;
    }

    .back {
        width: 7%;
    }
}

</style>